
import Vue from 'vue';
import { Getter, Action } from 'vuex-class';
import Component from 'vue-class-component';
import SearchCustomer from './SearchCustomer.vue';
import FileTable from './FileTable.vue';
import { Prop, Watch } from 'vue-property-decorator';
import { Message } from 'element-ui';
import * as util from '../conf';

@Component({
  components: { SearchCustomer, FileTable }
})
export default class ProductConsultation extends Vue {
  $refs: {
    [key: string]: any;
    validate: HTMLFormElement;
  };

  @Getter productSubsystemList: any;
  @Getter productModuleList: any;
  @Getter productEditionList: any;
  @Getter customerList: any;
  @Getter feedbackResult: any;
  @Getter feedbackDetail: any;
  @Getter defaultAssigneeByModule: any; // 模块默认经办人信息

  @Action('getProductSubsystemList') getProductSubsystemList: Function;
  @Action('getProductModuleList') getProductModuleList: Function;
  @Action('getProductEditionList') getProductEditionList: Function;
  @Action('getCustomerData') getCustomerData: Function;
  @Action('addFeedback') addFeedback: Function;
  @Action('getFeedbackDetailById') getFeedbackDetailById: Function;
  @Action('getDefaultAssigneeByModule') getDefaultAssigneeByModule: Function;  

  @Prop() TypeEnum: number;
  @Prop() assignee: any;
  @Prop() defaultAssignee: any;

  subdisabled:boolean=false;
  chooseCustomerVisible: boolean = false;
  isActivation: boolean = false;
  newAss: any = {};
  isShowEnterpriseCode: boolean = false;
  roboturl:string='';
  tjUrl:String='https://open.mingyuanyun.com/developer/support/order';
  // 表单数据
  form: any = {
    EnterpriseCode: '',
    SubSystemGUID: '',
    SubSystemName: '',
    ModuleGUID: '',
    ModuleName: '',
    EditionGUID: '',
    EditionName: '',
    CustomerTopName: '',
    CustomerGUID: '',
    CustomerArea: '',
    CustomerFullName: '',
    CustomerShortName: '',
    FeedbackTheme: '',
    FeedbackDescribe: '',
    FileUpload: '',
    assignee: { name: '' },
    FromType:'',   // 来源
    TicketId:'',    // 来源主键    
    OriginalAnalysis: '', // 原来的反馈分析
    OriginalFeedbackGUID: '' // 原来的反馈ID
  };

  rules: any = {
    EnterpriseCode: [
      {
        validator: (rule: any, value: any, callback: any) => {
          if (!value) return callback(new Error('企业代码不能为空'));
          callback();
        },
        trigger: 'blur'
      }
    ],
    SubSystemGUID: [
      {
        validator: (rule: any, value: any, callback: any) => {
          if (!value) return callback(new Error('所属子系统不能为空'));
          callback();
        },
        trigger: 'blur'
      }
    ],
    ModuleGUID: [
      {
        validator: (rule: any, value: any, callback: any) => {
          if (!value) return callback(new Error('模块不能为空'));
          callback();
        },
        trigger: 'blur'
      }
    ],
    EditionGUID: [
      {
        validator: (rule: any, value: any, callback: any) => {
          if (!value) return callback(new Error('产品版本不能为空'));
          callback();
        },
        trigger: 'blur'
      }
    ],
    PmName: [
      {
        validator: (rule: any, value: any, callback: any) => {
          if (!value) return callback(new Error('二开PM不能为空'));
          callback();
        },
        trigger: 'blur'
      }
    ],
    ProjectName: [
      {
        validator: (rule: any, value: any, callback: any) => {
          if (!value) return callback(new Error('项目名称不能为空'));
          callback();
        },
        trigger: 'blur'
      }
    ],
    FeedbackTheme: [
      {
        validator: (rule: any, value: any, callback: any) => {
          if (!value) return callback(new Error('咨询主题不能为空'));
          callback();
        },
        trigger: 'blur'
      }
    ],
    FeedbackDescribe: [
      {
        validator: (rule: any, value: any, callback: any) => {
          if (!value) return callback(new Error('产品咨询内容不能为空'));
          callback();
        },
        trigger: 'blur'
      }
    ]
  };

 setsubdisabled(value:boolean) {    
    this.subdisabled=value;
 }

  checkCuetomer(rule: any, value: any, callback: any) {
    if (!value) return callback(new Error('客户名称不能为空'));
    if (
      !this.isActivation &&
      (!this.customerList.data ||
        !this.customerList.data.find(
          (item: any) => item.CustomerFullName === value
        ))
    ) {
      return callback(new Error('客户名称无效'));
    }
    callback();
  }

  created() {
    this.reactivation();
    this.form.CompayType = util.getUserAreaType();
    this.form.BUName = util.getUserBUName();
    this.getProductSubsystemList();
    this.rules.CustomerFullName = {
      validator: this.checkCuetomer,
      trigger: 'blur'
    };    
    const user = JSON.parse(localStorage.logonUser);
     this.roboturl =
     "https://robotapi.fdcyun.com/?channel=corp&redirect=/&biz_id=CORP-XIAOSHOU&version=CORP-XIAOSHOU&userguid=" +
      user.UserGUID +
      "&phone=" +
      user.MobilePhone +
      "&email=" +
      user.Email +
      "&username=" +
      user.UserName +
      "&openid=" +
      user.UserCode +
      "";

    this.form.FromType=this.$route.query.fromType;
    this.form.TicketId=this.$route.query.ticketId;
  }

  
  mounted(){
    if(window.opener){
    //event 参数中有 data 属性，就是父窗口发送过来的数据
    window.addEventListener("message", this.setlocalStorage, false );

    // 通知打开页面的主体，页面加载完成
    window.opener.postMessage("加载完成", "*");
    }
    this.roboturl =this.roboturl +"&q="+this.form.FeedbackTheme;
  }


  setlocalStorage(event:any) {
    const feedback = event.data; 
    if (!feedback  || !feedback.ViewData ) {
      this.subdisabled = true;
      return;
    }
    if(event.origin!='http://localhost:5000' 
    && event.origin!='https://upgrade.mingyuanyun.com' 
    && event.origin!='http://upgrade-test.mingyuanyun.com'){
        return ;
    }
      this.subdisabled = false;
      this.form.SubSystemGUID=feedback.ViewData.SystemGUID;
      this.form.SubSystemName=feedback.ViewData.SystemName;
      // 设置经办人 企业代码
      this.setAssignee(this.form.SubSystemGUID);
      this.setEnterpriseCode(this.form.SubSystemGUID);
            // 选择模块
      this.getProductModuleList({
        typeEnum: this.TypeEnum,
        subSystemName: this.form.SubSystemName
      });

      this.form.ModuleGUID=feedback.ViewData.ModuleGUID;
      this.form.ModuleName=feedback.ViewData.ModuleName;      
      // 选择版本
      this.getProductEditionList({
        typeEnum: this.TypeEnum,
        subSystemName: this.form.SubSystemName
      });
            // 输入客户名称
      this.getCustomerData({
        keyword: feedback.ViewData.CustomerGUID,
        isPage: false,
        top: 100
      });

      this.form.CustomerTopName = feedback.ViewData.CustomerTopName;
      this.form.CustomerGUID = feedback.ViewData.CustomerGUID;
      this.form.CustomerArea = feedback.ViewData.CustomerArea;
      this.form.CustomerFullName = feedback.ViewData.CustomerFullName;
      this.form.CustomerShortName = feedback.ViewData.CustomerShortName;
      this.form.FeedbackTheme = feedback.ViewData.Theme;
      this.form.FeedbackDescribe = feedback.ViewData.Remark;    
  }



  // 重新激活的处理过程
  reactivation() {
    if (
      this.$route.query.FeedbackGUID &&
      this.$route.query.FeedbackGUID !== ''
    ) {
      this.isActivation = true;
      this.form.OriginalFeedbackGUID = this.$route.query.FeedbackGUID;
      this.getFeedbackDetailById({
        FeedbackGUID: this.$route.query.FeedbackGUID
      });
    }
  }

  @Watch('feedbackDetail.loading')
  watchFeedbackDetail(newVal: boolean, oldVal: boolean) {
    // oldVal: true, newVal: fasle, 表示接口请求完成，loading页面即将加载完成
    if (oldVal === true && newVal === false) {
      const data = JSON.parse(JSON.stringify(this.feedbackDetail.data));
      const detailInfo =
        data.length > 0
          ? data.find((item: any) => item.SourceEnum === 1) || data[0]
          : {};
      // 选择主系统
      this.form.SubSystemGUID = detailInfo.SubSystemGUID;
      this.form.SubSystemName = detailInfo.SubSystemName;
      this.setEnterpriseCode(this.form.SubSystemGUID);
      this.form.EnterpriseCode = detailInfo.EnterpriseCode;
      // 选择模块
      this.getProductModuleList({
        typeEnum: this.TypeEnum,
        subSystemName: detailInfo.SubSystemName
      });
      this.form.ModuleGUID = detailInfo.ModuleGUID;
      this.form.ModuleName = detailInfo.ModuleName;
      // 选择版本
      this.getProductEditionList({
        typeEnum: this.TypeEnum,
        subSystemName: detailInfo.SubSystemName
      });
      this.form.EditionGUID = detailInfo.EditionGUID;
      this.form.EditionName = detailInfo.EditionName;
      // 输入客户名称
      this.getCustomerData({
        keyword: detailInfo.CustomerFullName,
        isPage: false,
        top: 100
      });
      this.form.CustomerTopName = detailInfo.CustomerTopName;
      this.form.CustomerGUID = detailInfo.CustomerGUID;
      this.form.CustomerArea = detailInfo.CustomerArea;
      this.form.CustomerFullName = detailInfo.CustomerFullName;
      this.form.CustomerShortName = detailInfo.CustomerShortName;
      // 主题
      this.form.FeedbackTheme = detailInfo.FeedbackTheme;
      // 描述
      this.form.FeedbackDescribe = detailInfo.FeedbackDescribe;
      // 原反馈分析
      this.form.OriginalAnalysis = detailInfo.Analysis;
      // 附件
      this.form.FileUpload = detailInfo.FileUpload;
      this.$refs.filetable.appendFileList(
        detailInfo.FileUpload ? JSON.parse(detailInfo.FileUpload) : []
      );
      // 经办人
      this.form.assignee.name = detailInfo.OperateUserCode;
      this.newAss.displayName = detailInfo.OperateName;
    }
  }

  @Watch('defaultAssignee.loading')
  watchDefaultAssignee(newVal: boolean, oldVal: boolean) {
    // oldVal: true, newVal: fasle, 表示接口请求完成，loading页面即将加载完成
    if (oldVal === true && newVal === false) {
      this.setAssignee(this.form.SubSystemGUID);
      this.setEnterpriseCode(this.form.SubSystemGUID);
    }
  }

  @Watch('assignee.loading')
  watchAssignee(newVal: boolean, oldVal: boolean) {
    // oldVal: true, newVal: fasle, 表示接口请求完成，loading页面即将加载完成
    if (oldVal === true && newVal === false) {
      this.setAssignee(this.form.SubSystemGUID);
    }
  }


  // 选择子系统
  changeSubsystem(key: any) {
    this.setAssignee(key);
    this.setEnterpriseCode(key);
    this.form.ModuleGUID = '';
    this.form.EditionGUID = '';
    const subsystem = this.productSubsystemList.data.find(
      (item: any) => item.SubSystemGUID === key
    );
    if (subsystem) {
      this.getProductModuleList({
        subSystemName: subsystem.SubSystemName
      });
      this.getProductEditionList({
        subSystemName: subsystem.SubSystemName
      });
      // 查找模块默认经办人信息
      this.getDefaultAssigneeByModule({
        subSystemName: subsystem.SubSystemName
      });         
    }
    this.$refs.form.validateField('SubSystemGUID');
  }

  // 选择模块
  changeModule(key: any) {
    this.$refs.form.validateField('ModuleGUID');
    // 获取模块默认经办人 如果存在替换经办人字段，如果不存在 不替换
    var user = this.defaultAssigneeByModule.data.find((item:any) => item.ModuleGUID===key);
    if(user && user.JiraUserId != null){        
        this.assignee.data.map((ass:any)=>{
          if(ass.id === user.JiraUserId){
            this.newAss = ass;
            this.form.assignee.name = ass.name;
          }
        });
    }else if(user){
      // 如果模块没有设置默认经办人，默认经办人改为子系统默认经办人
      this.setAssignee(user.SubSystemGUID);
    }
  }

  // 选择子系统
  changeEdition(key: any) {
    this.$refs.form.validateField('EditionGUID');
  }

  // 客户搜索结果(value表示的是下拉的文字)
  queryCustomerAsync(keyword: string, cb: Function) {
    let customerResult: any = [];
    if (keyword) {
      this.getCustomerData({ keyword, isPage: false, top: 100 }).then(
        (data: any) => {
          if (data && data.Items) {
            data.Items.forEach(
              (item: any) => (item.value = item.CustomerFullName)
            );
            customerResult = data.Items;
          }
          cb(customerResult);
        }
      );
    } else {
      cb(customerResult);
    }
  }

  // 设置默认经办人
  setAssignee(sysid: any) {
    // 先置为空
    this.newAss={};
    this.form.assignee.name='';
    this.defaultAssignee.data.map((item: any) => {
      if (item.SubSystemGuid === sysid) {
        this.assignee.data.map((ass: any) => {
          if (ass.id === item.JiraUserId.toString()) {
            this.newAss = ass;
            this.form.assignee.name = ass.name;
          }
        });
      }
    });
  }

  // 设置是否需要填写企业代码
  setEnterpriseCode(sysid: any) {
    // 云助手 10808
    // HightData 10809
    // 移动计划 11192
    // 反馈流程测试 11333
    const needEnterpriseCodeSys = ['10808', '10809', '11192', '11333'];
    if (needEnterpriseCodeSys.includes(sysid)) {
      this.defaultAssignee.data.map((item: any) => {
        if (item.SubSystemGuid === sysid) {
          this.isShowEnterpriseCode = !item.IsHandleByProject;
        }
      });
    } else {
      this.isShowEnterpriseCode = false;
    }
  }

  // 确定选择的客户（模糊搜索）
  handleSelectCustomer(item: any) {
    this.form.CustomerGUID = item.CustomerGUID;
    this.form.CustomerArea = item.CustomerArea; // 客户区域
    this.form.CustomerFullName = item.CustomerFullName; // 客户全称
    this.form.CustomerTopName = item.CustomerTopName; // 顶级客户(简称)
    this.form.CustomerShortName = item.CustomerShortName; // 客户简称
    this.$refs.form.validateField('CustomerFullName');
  }

  // 打开选择客户弹窗
  chooseCustomer() {
    this.chooseCustomerVisible = true;
  }

  // 关闭选择客户
  closeChooseCustomerVisible(close: boolean) {
    this.chooseCustomerVisible = false;
  }

  // 确定选择客户（弹窗选择）
  confirmSelectedCustomer(val: { [key: string]: any }) {
    if (!!val) {
      this.form.CustomerGUID = val.CustomerGUID; // 客户GUID
      this.form.CustomerArea = val.CustomerArea; // 客户区域
      this.form.CustomerFullName = val.CustomerFullName; // 客户全称
      this.form.CustomerTopName = val.CustomerTopName; // 顶级客户(简称)
      this.form.CustomerShortName = val.CustomerShortName; // 客户简称
    }
    this.chooseCustomerVisible = false;
    this.$refs.form.validateField('CustomerFullName');
  }

  confirmFileList(fileList: any[]) {
    this.form.FileUpload = JSON.stringify(fileList);
  }

  // 提交表单
  onSubmit(formName: string) {
    const form = this.$refs[formName];
    form.validate((valid: any) => {
      if (valid) {
        this.subdisabled=true;
        this.form.TypeEnum = this.TypeEnum;
        const subsystem = this.productSubsystemList.data.find(
          (item: any) => item.SubSystemGUID === this.form.SubSystemGUID
        );
        this.form.SubSystemName = subsystem.SubSystemName;
        const moduleInfo = this.productModuleList.data.find(
          (item: any) => item.ModuleGUID === this.form.ModuleGUID
        );
        this.form.ModuleName = moduleInfo.ModuleName;
        const edition = this.productEditionList.data.find(
          (item: any) => item.EditionGUID === this.form.EditionGUID
        );
        this.form.EditionName = edition.EditionName;
        // 防止重复提交
        if (
          !this.feedbackResult.success ||
          this.feedbackResult.request.FeedbackTheme !== this.form.FeedbackTheme
        ) {
          debugger;
          const body = Object.assign({}, this.form); // 解决接口报错时，重复叠加data的问题
          this.addFeedback(body);
        } else {
          Message.info('已经提交成功');
          this.subdisabled=false;
        }
      } else {
        return false;
      }
    });
  }
}
